import "animate.css";
import "./Banner.css";
import { FiMapPin, FiPhone, FiClock, FiArrowUpRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import Bannerleft from "../../../pages/Masala-of-india/assets/images/banner/banneleftshape.webp";
import Bannerright from "../../../pages/Masala-of-india/assets/images/banner/bannerightshape.webp";
import Bannerbg from "../../../pages/Masala-of-india/assets/images/banner/bannerbg.png";
import catering from "../../../pages/Masala-of-india/assets/images/cards/catering.jpg";
import menu from "../../../pages/Masala-of-india/assets/images/cards/menu.jpg";
import reservation from "../../../pages/Masala-of-india/assets/images/cards/reservation.jpg";

const CommonHomeBanner = () => {
  const items = [
    {
      icon: <FiMapPin />,
      title: "Visit Us",
      text: (
        <>
          507 NE Northgate Way, <br /> Suite G Seattle, WA 98125
        </>
      ),
      action: "Directions",
      link: "https://maps.app.goo.gl/JLwg6KfcoNVttSj77",
    },
    {
      icon: <FiPhone />,
      title: "Call Us",
      text: "206-417-1118",
      action: "Call Now",
      link: "tel:2064171118",
    },
    {
      icon: <FiClock />,
      title: "Opening Hours",
      text: (
        <>
          Monday - Sunday <br /> 10:00 AM - 10:00 PM
        </>
      ),
      action: "We're Open",
      link: "https://maps.app.goo.gl/JLwg6KfcoNVttSj77",
    },
  ];
  const cards = [
    {
      id: 1,
      image: menu,
      title: "Menu",
      link: "/menu",
    },
    { id: 2, image: catering, title: "Catering", link: "/catering" },
    {
      id: 3,
      image: reservation,
      title: "Reservation",
      link: "/reservation",
    },
  ];
  return (
    <>
      <section className="banner-section">
        <img
          className="img1 wow fadeInLeft"
          data-wow-delay=".7s"
          src={Bannerleft}
          alt="Masala of India Banner"
          loading="lazy"
        />
        <img
          className="img2 wow fadeInRight"
          data-wow-delay=".7s"
          src={Bannerright}
          alt="Masala of India Banner"
          loading="lazy"
        />
        <img
          className="img3"
          src={Bannerbg}
          alt="Masala of India Banner"
          loading="lazy"
        />
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="main-content">
                <h1
                  className="main-sub-title wow fadeInLeft"
                  data-wow-delay=".2s">
                  Best Indian Restaurant in Northgate,{" "}
                  <br className="d-block d-md-none" /> Seattle
                </h1>
                <h2
                  className="main-title wow fadeInRight mb-1 pb-lg-1"
                  data-wow-delay=".2s">
                  Serving Authentic <br />
                  Indian Food
                </h2>
                {/* <div className="myBtn">
                  <Link to="/menu">our menu</Link>
                  <Link
                    to="https://maps.app.goo.gl/JLwg6KfcoNVttSj77"
                    target="_blank">
                    get direction
                  </Link>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-strip">
        <div className="contact-strip__inner">
          {items.map((item, index) => (
            <div className="contact-item" key={index}>
              <div className="contact-icon">{item.icon}</div>

              <div className="contact-info">
                <span>{item.title}</span>
                <p>{item.text}</p>
              </div>

              {item.link ? (
                <a
                  href={item.link}
                  target={item.link.startsWith("http") ? "_blank" : undefined}
                  rel="noopener noreferrer"
                  className="contact-action">
                  {item.action}
                  <FiArrowUpRight />
                </a>
              ) : (
                <div className="contact-open">
                  <i />
                  {item.action}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      <section className="three-card-section">
        <div className="container">
          <div className="cards-grid">
            {cards.map((card) => (
              <div className="image-card" key={card.id}>
                <img src={card.image} alt={card.title} />

                {/* Overlay */}
                <div className="card-overlay">
                  <Link to={card.link} className="card-button">
                    {card.title}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default CommonHomeBanner;
